import axios from 'axios';
import API_BASE_URL from './apiConfig';

const api = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    withCredentials: true,
    withXSRFToken: true,
});

// Sanctum SPA handshake: fetches the XSRF-TOKEN cookie before an
// unauthenticated request (login/register) is made. Not routed through
// `api` since this endpoint is a sibling of /api, not under it.
export const ensureCsrfCookie = () =>
    axios.get(`${API_BASE_URL}/sanctum/csrf-cookie`, { withCredentials: true });

let onUnauthorized = null;
export const setUnauthorizedHandler = (handler) => {
    onUnauthorized = handler;
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(error);
    }
);

export default api;
